import React from 'react';

const MagnifierIcon: React.FC<{ size?: number; color?: string }> = ({ size = 20, color = '#3182ce' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="7" stroke={color} strokeWidth="2" />
    <line x1="14.1213" y1="14.1213" x2="18" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default MagnifierIcon;

